// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"5fcf6829","171":"6395b63a","453":"b03e3c98","456":"697584aa","507":"5009724a","801":"9c065ec7"}[chunkId] + ".chunk.js";
};